import { GPUEngineStatisticsInfo } from "../../../RenderEngine/RenderEnum/RenderStatInfo";
import { WebGLEngine } from "./WebGLEngine";
export class WebGLVertexBuffer {
    get vertexDeclaration() {
        return this._vertexDeclaration;
    }
    set vertexDeclaration(value) {
        this._vertexDeclaration = value;
        this._shaderValues = this._vertexDeclaration._shaderValues;
    }
    constructor(targetType, bufferUsageType) {
        this._glBuffer = WebGLEngine.instance.createBuffer(targetType, bufferUsageType);
        WebGLEngine.instance._addStatisticsInfo(GPUEngineStatisticsInfo.RC_VertexBuffer, 1);
    }
    _changeMemory(bytelength) {
        WebGLEngine.instance._addStatisticsInfo(GPUEngineStatisticsInfo.M_VertexBuffer, -this._glBuffer._byteLength + bytelength);
    }
    setDataLength(byteLength) {
        this._changeMemory(byteLength);
        this._glBuffer.setDataLength(byteLength);
    }
    setData(buffer, bufferOffset, dataStartIndex, dataCount) {
        this.bind();
        var needSubData = dataStartIndex !== 0 || dataCount !== Number.MAX_SAFE_INTEGER;
        if (needSubData) {
            var subData = new Uint8Array(buffer, dataStartIndex, dataCount);
            this._glBuffer.setData(subData, bufferOffset);
        }
        else {
            this._glBuffer.setData(buffer, bufferOffset);
        }
    }
    bind() {
        return this._glBuffer.bindBuffer();
    }
    unbind() {
        return this._glBuffer.unbindBuffer();
    }
    orphanStorage() {
        this.bind();
        this._glBuffer.setDataLength(this._glBuffer._byteLength);
    }
    destroy() {
        this._glBuffer.destroy();
        this._vertexDeclaration = null;
        this._changeMemory(0);
        WebGLEngine.instance._addStatisticsInfo(GPUEngineStatisticsInfo.RC_VertexBuffer, -1);
    }
}
